export class ChaseDetailForAuditItem {
  action: string;
  auditPackageId: number;
  auditPackageIds?: number[];
  auditPackageItemId?: number;
  auditReady?: string;
  chaseId: number;
  diagnosisPageNumber?: number;
  measureCode: string;
  measureId: number;
  memberDOB: string;
  memberFirstName: string;
  memberId: number;
  memberLastName: string;
  entityId?: number;
  numeratorCode: string;
  numeratorId: number;
  numeratorName: string;
  projectId: number;
  userRank?: number;
  status?: string;
  icdCode?: string;
  hccCode?: string;
  cmsModel?: string;
  encounterType?: string;
  paymentYear?: number;
  planId?: string;
  product?: string;
  hccValidationResult?: string;

  constructor(options: {
    action?: string;
    auditPackageId?: number;
    auditPackageIds?: number[];
    auditPackageItemId?: number;
    auditReady?: string;
    chaseId?: number;
    diagnosisPageNumber?: number;
    measureCode?: string;
    measureId?: number;
    memberDOB?: string;
    memberFirstName?: string;
    memberId?: number;
    memberLastName?: string;
    numeratorCode?: string;
    numeratorId?: number;
    entityId?: number;
    projectId?: number;
    userRank?: number;
    status?: string;
    icdCode?: string;
    hccCode?: string;
    cmsModel?: string;
    encounterType?: string;
    paymentYear?: number;
    planId?: string;
    product?: string;
    hccValidationResult?: string;
  } = {}) {
    this.action = options.action;
    this.auditPackageId = options.auditPackageId;
    this.auditPackageIds = options.auditPackageIds;
    this.auditPackageItemId = options.auditPackageItemId;
    this.auditReady = options.auditReady;
    this.chaseId = options.chaseId;
    this.diagnosisPageNumber = options.diagnosisPageNumber;
    this.measureCode = options.measureCode;
    this.measureId = options.measureId;
    this.memberDOB = options.memberDOB;
    this.memberFirstName = options.memberFirstName;
    this.memberId = options.memberId;
    this.memberLastName = options.memberLastName;
    this.numeratorCode = options.numeratorCode;
    this.numeratorId = options.numeratorId;
    this.entityId = options.entityId;
    this.projectId = options.projectId;
    this.userRank = options.userRank;
    this.status = options.status;
    this.icdCode = options.icdCode;
    this.hccCode = options.hccCode;
    this.cmsModel = options.cmsModel;
    this.encounterType = options.encounterType;
    this.paymentYear = options.paymentYear;
    this.planId = options.planId;
    this.product = options.product;
    this.hccValidationResult = options.hccValidationResult;
  }

  toApiRequest(): any {
    return {
      Action: this.action,
      AuditPackageId: this.auditPackageId,
      AuditPackageIds: this.auditPackageIds,
      AuditPackageItemId: this.auditPackageItemId,
      AuditReady: this.auditReady,
      ChaseId: this.chaseId,
      DiagnosisPageNumber: this.diagnosisPageNumber,
      MeasureCode: this.measureCode,
      MeasureId: this.measureId,
      MemberDOB: this.memberDOB,
      MemberFirstName: this.memberFirstName,
      MemberId: this.memberId,
      MemberLastName: this.memberLastName,
      NumeratorCode: this.numeratorCode,
      NumeratorId: this.numeratorId,
      EntityId: this.entityId,
      ProjectId: this.projectId,
      UserRank: this.userRank,
      Status: this.status,
      IcdCode: this.icdCode,
      HccCode: this.hccCode,
      CmsModel: this.cmsModel,
      EncounterTypeXml: this.encounterType,
      PaymentYear: this.paymentYear,
      PlanId: this.planId,
      Product: this.product,
      HccValidationResult: this.hccValidationResult,
    };
  }
}
